import * as React from 'react'

import { spacing, Strong } from 'main/ui'

interface IProps {
  children: React.ReactNode
  label: string
}

export default function FormItem(props: IProps) {
  const { children, label } = props

  return (
    <div>
      <div css={{ marginBottom: spacing.majorScale(1) }}>{<Strong>{label}</Strong>}</div>
      {children}
    </div>
  )
}
